import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import axios from 'axios';
// import { Grid } from 'gridjs-react';
// import { DataGrid } from '@mui/x-data-grid';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
// import Link from '@mui/material/Link';

import { DatatableWrapper, Filter, TableBody, TableHeader } from 'react-bs-datatable';
import { Table } from 'react-bootstrap';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { fetchToken } from '../components/Auth';
import CustomPagination from '../components/Pagination';

export default function Client() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(null);

  useEffect(() => {
    getClients(currentPage).then((response) => {
      if (response.status === 200) {
        const data = response.data.map((r) => {
          const account = r.account || { email: null };
          return { id: r.id, name: r.name, email: account.email };
        });
        setData(data);
      }
      // setData(data.slice(0).concat([row()]));
    });
  }, [currentPage]);

  const handleShowUnitList = (event, cellValues) => {
    navigate('/clients/' + cellValues.row.id + '/units');
  };

  const handleCreateUnit = (event, cellValues) => {
    navigate('/clients/' + cellValues.row.id + '/units/new');
  };

  const handleShowDetail = (event, cellValues) => {
    navigate('/clients/' + cellValues.row.id);
  };

  const columns = [
    {
      prop: 'id',
      title: 'ID',
      width: 100,
    },
    {
      prop: 'name',
      title: '企業名',
      width: 150,
      cell: (row) => (
        <>
          <Button
            variant="link"
            size="sm"
            className="text-start client-name-btn"
            // href={'/clients/' + params.row.id}
            onClick={(event) => {
              handleShowDetail(event, { row: row });
              return false;
            }}
          >
            {row.name}
          </Button>
        </>
      ),
    },
    { prop: 'email', title: 'メールアドレス', isFilterable: true, width: 200 },
    {
      prop: 'showUnitsList',
      title: '',
      sortable: false,
      width: 120,
      cell: (row) => (
        <>
          <Button
            className="client-units-btn"
            variant="dark"
            size="sm"
            onClick={(event) => {
              handleShowUnitList(event, { row: row });
            }}
          >
            施策一覧
          </Button>
        </>
      ),
    },
    {
      prop: 'createUnit',
      title: '',
      sortable: false,
      width: 120,
      cell: (row) => (
        <>
          <Button
            className="client-create-btn"
            variant="dark"
            size="sm"
            onClick={(event) => {
              handleCreateUnit(event, { row: row });
            }}
          >
            施策登録
          </Button>
        </>
      ),
    },
  ];

  const getClients = (page) => {
    const limit = 100;
    const skip = limit * (page - 1);

    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const response = Promise.all([
      axios.get('/api/v1/clients/', { params: { skip, limit }, headers: headers }),
      axios.get('/api/v1/clients/count/', { headers: headers }),
    ])
      .then(([resClients, resCount]) => {
        setPageTotal(Math.ceil(resCount.data / limit));
        return resClients;
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          localStorage.removeItem('temitope');
          navigate('/login');
        }
        return error.response.status;
      });

    return response;
  };

  return (
    <div className='client-list'>
      <Header />
      <main>
        <Container>
          <h2 className="client-list-title">クライアント一覧</h2>
          <div className="client-list-wrapper">
            <DatatableWrapper headers={columns} body={data}>
              <Filter placeholder="メールアドレス検索" />
           <div className="my-3 client-list-scroll">
                <Table>
                  <TableHeader />
                  <TableBody />
                </Table>
              </div>
            </DatatableWrapper>

            <CustomPagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageTotal={pageTotal}
            ></CustomPagination>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
